export default __webpack_public_path__ + "static/media/running-mass-action.efc82d70.svg";